import { graphql } from "@repo/graphql-types/gql";
import { useRouter, useSearch } from "@tanstack/react-router";
import { type Patient } from "@repo/lib";
import { useSetAtom } from "jotai";
import { useGraphQL } from "@/hooks/use-graphql";
import { PatientList } from "@/components/patient-list";
import { recommendationPatientAtom } from "@/lib/atoms/recommendation-patient-atom";

export const RecommendationPatientsForMemberQuery = graphql(/* GraphQL */ `
  query RecommendationPatientsForMemberQuery {
    ...PatientListQueryFragment
  }
`);

export const RecommendationPatientsForMemberSearch = (): JSX.Element => {
  const router = useRouter();
  const params = useSearch({ from: "/recommendation/" });

  const setPatientAtomValues = useSetAtom(recommendationPatientAtom);

  const queryResult = useGraphQL(RecommendationPatientsForMemberQuery);
  const { data } = queryResult;

  const handleClickItem = (patient: Patient): void => {
    setPatientAtomValues({
      id: patient.patientId,
      name: patient.name,
    });

    void router.navigate({
      to: "/recommendation/confirmation",
      search: {
        userId: params.userId,
      },
    });
  };

  return (
    <div>
      {data ? <PatientList patientList={data} onClick={handleClickItem} /> : null}
    </div>
  );
};
